import request from '@/api/request'

// Health status for components, disk space, etc.
export function systemMonitorgetHealth() {
  return request({
    url: '/health',
    method: 'get',
  })
}

// Certificate check
export function systemMonitorgetCert() {
  return request({
    url: '/system/getCert',
    method: 'get',
  })
}

// Additional health check info (meta/env/queue/config)
export function systemMonitorgetHealthCheck() {
  return request({
    url: '/healthCheck',
    method: 'get',
  })
}

